import React from 'react';
import SuccessIcon from '@atlaskit/icon/core/migration/check-circle';
import ErrorIcon from '@atlaskit/icon/core/migration/error';
import { G300, R400 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';
import AutoDismissFlag from '@atlassian/jira-flags/src/common/ui/components/ak-auto-dismiss-flag';
import FlagGroup from '@atlassian/jira-flags/src/common/ui/components/group-flag';
import { SUCCESS_TYPE } from '@atlassian/jira-servicedesk-common/src/model/flags/index.tsx';
import type { Flag } from '../../common/types.tsx';

export type KbFlagsProps = {
	flags: Flag[];
	onDismissed: (id: string | number) => Promise<undefined> | undefined;
};

export const KbFlags = ({ flags, onDismissed }: KbFlagsProps) => (
	<FlagGroup
		onDismissed={(id: string | number) => {
			onDismissed(id);
		}}
	>
		{flags.map(({ flagType, title, description, id }) => (
			<AutoDismissFlag
				id={id}
				icon={
					flagType && flagType === SUCCESS_TYPE ? (
						<SuccessIcon label="Success" color={token('color.icon.success', G300)} />
					) : (
						<ErrorIcon label="Error" color={token('color.icon.danger', R400)} />
					)
				}
				key={id}
				title={title}
				description={description}
				messageId="servicedesk-knowledge-common.ui.kb-flags.auto-dismiss-flag"
				messageType="transactional"
			/>
		))}
	</FlagGroup>
);

export default KbFlags;
